import { useState } from "react";
import RoleBadge from "../../../components/Profile/RoleBadge/RoleBadge";
import StandardPopup from "../../../components/Global/StandardPopup/StandardPopup";
import AdminBlock from "./AdminBlock";
import strings from "../../../locales/ro.json";
import "./RolesManager.css";

const RolesList = ({ roles, onDelete, loading }) => {
  const [deleteTarget, setDeleteTarget] = useState(null);

  const handleDelete = async () => {
    if (!deleteTarget) return;
    try {
      await onDelete(deleteTarget);
    } catch (_) {
      // error handled in hook
    }
    setDeleteTarget(null);
  };

  if (roles.length === 0) {
    return (
      <AdminBlock title={strings.admin.roles.list.title} defaultOpen={true}>
        <p className="rm-empty">{strings.admin.roles.list.empty}</p>
      </AdminBlock>
    );
  }

  // Group roles by role_type
  const grouped = {};
  roles.forEach((role) => {
    const typeLabel = role.role_type?.label || strings.admin.roles.list.othersCategory;
    if (!grouped[typeLabel]) grouped[typeLabel] = [];
    grouped[typeLabel].push(role);
  });

  return (
    <AdminBlock title={strings.admin.roles.list.title} defaultOpen={true}>
      <div className="rm-roles-list-content">
        {Object.entries(grouped).map(([typeLabel, typeRoles]) => (
          <div key={typeLabel} className="rm-role-group">
            <h4 className="rm-role-group-title">{typeLabel}</h4>
            <div className="rm-role-items">
              {typeRoles.map((role) => (
                <div key={role.id} className="rm-role-item">
                  <RoleBadge name={role.name} color={role.color} />
                  <button
                    className="rm-delete-btn"
                    onClick={() => setDeleteTarget(role.id)}
                    disabled={loading}
                    title={strings.admin.roles.list.deleteTitle}
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          </div>
        ))}

        <StandardPopup
          isOpen={!!deleteTarget}
          message={strings.admin.roles.list.deleteConfirm}
          yesFcn={handleDelete}
          noFcn={() => setDeleteTarget(null)}
        />
      </div>
    </AdminBlock>
  );
};

export default RolesList;
